import React from "react";
import { LogoLeaf } from "../../../assets/logo/LogoLeaf";
import TipsListStyle from "../../../assets/stylesheets/farm-detail/sections/TipsList.module.css";
import FarmDetailStyle from "../../../assets/stylesheets/farm-detail/FarmDetailPage.module.css";
import Logger from "../../../utils/logger";

// const log = Logger.create('TipsList');

const TIP_TITLE = "Just a few friendly reminders";

export default function TipList({tips}) {

  return (
    <div className={`${TipsListStyle["tip-list-container"]}`}>
      <div className={TipsListStyle["tip-list-box"]}>
        <h3 className={FarmDetailStyle["farmDetail-title"]}>{TIP_TITLE}</h3>
      </div>
      <div className={TipsListStyle["tip-list-items"]}>
        {tips.map((tip, idx) => (
          <div key={idx} className={TipsListStyle["tip-row"]}>
            <LogoLeaf className={TipsListStyle["tip-list-icon"]} aria-label="Tip Icon" />
            <div className={TipsListStyle["tip-content"]}>
              <div className={TipsListStyle["tip-list-title"]}>
                {tip.title}
              </div>
              <div className={TipsListStyle["tip-list-text"]}>
                {tip.text}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
